<dialog
  #dialogRef
  class="lightbox-dialog"
  tabindex="0"
  (keydown)="onKeydown($event)"
  (cancel)="$event.preventDefault()"
>
  <div class="lightbox-container">
    <!-- Top bar -->
    <div class="lightbox-header">
      <div class="lightbox-tabs">
        <button
          type="button"
          #galleryTab
          [class]="mode() === 'gallery' ? 'lightbox-tab lightbox-tab--active' : 'lightbox-tab'"
          (click)="switchToGallery()"
        >
          <svg viewBox="0 -960 960 960" class="h-7 w-7 fill-current" aria-hidden="true">
            <path
              d="M363.08-406.15h373.84L612.77-569.23l-95.08 121.54-62.77-77.69-91.84 119.23ZM322.31-260Q292-260 271-281q-21-21-21-51.31v-455.38Q250-818 271-839q21-21 51.31-21h455.38Q808-860 829-839q21 21 21 51.31v455.38Q850-302 829-281q-21 21-51.31 21H322.31Zm0-60h455.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46v-455.38q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H322.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v455.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85Zm-140 200Q152-120 131-141q-21-21-21-51.31v-515.38h60v515.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h515.38v60H182.31ZM310-800v480-480Z"
            />
          </svg>
          <span class="hidden sm:inline">Photos</span>
        </button>

        @if (youtubeId()) {
          <button
            id="tour-button"
            type="button"
            #tourTab
            [class]="mode() === 'tour' ? 'lightbox-tab lightbox-tab--active' : 'lightbox-tab'"
            (click)="switchToTour()"
          >
            <svg viewBox="0 -960 960 960" class="h-7 w-7 fill-current" aria-hidden="true">
              <path
                d="M460-398.46 711.54-560 460-721.54v323.08ZM322.31-260Q292-260 271-281q-21-21-21-51.31v-455.38Q250-818 271-839q21-21 51.31-21h455.38Q808-860 829-839q21 21 21 51.31v455.38Q850-302 829-281q-21 21-51.31 21H322.31Zm0-60h455.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46v-455.38q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H322.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v455.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85Zm-140 200Q152-120 131-141q-21-21-21-51.31v-515.38h60v515.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h515.38v60H182.31ZM310-800v480-480Z"
              />
            </svg>
            <span class="hidden sm:inline">Tour</span>
          </button>
        }

        @if (hasMap()) {
          <button
            type="button"
            #mapTab
            [class]="mode() === 'map' ? 'lightbox-tab lightbox-tab--active' : 'lightbox-tab'"
            (click)="switchToMap()"
          >
            <svg viewBox="0 -960 960 960" class="h-7 w-7 fill-current" aria-hidden="true">
              <path
                d="M600.77-126.92 359.23-213.08l-174.38 67.31Q165.46-137.85 150-149.96q-15.46-12.12-15.46-33.5v-539.08q0-14.54 8.65-26.19 8.66-11.65 22.43-16.19L360-833.08l241.54 86.16 174.38-67.31q19.39-7.92 34.85 4.19 15.46 12.12 15.46 33.5v539.08q0 14.54-8.65 26.19-8.66 11.65-22.43 16.19L600.77-126.92ZM570-215.38v-472.47l-180-64.3v472.46l180 64.31Zm60 1.53 150-53.07v-477.39l-150 56.93v473.53Zm-390-19.3 150-56.93v-473.54l-150 53.08v477.39Zm390-454.23v473.53-473.53Zm-390-0.16v477.39-477.39Z"
              />
            </svg>
            <span class="hidden sm:inline">Map</span>
          </button>
        }
      </div>

      @if (mode() === 'gallery' && images().length > 0) {
        <span class="lightbox-counter">{{ counter() }}</span>
      }

      <button type="button" class="lightbox-close" (click)="close()" aria-label="Close lightbox">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          class="h-6 w-6"
          aria-hidden="true"
        >
          <path d="M6 18 18 6M6 6l12 12" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
    </div>

    <!-- Gallery mode -->
    <div
      class="lightbox-gallery"
      [style.display]="mode() !== 'gallery' ? 'none' : null"
      (pointerdown)="onPointerDown($event)"
      (pointerup)="onPointerUp($event)"
      (pointercancel)="onPointerCancel($event)"
    >
      @if (images().length > 0) {
        <img [src]="currentImage()" alt="Listing photo" class="lightbox-image" />

        @if (images().length > 1) {
          <button
            id="previous-image"
            type="button"
            class="lightbox-nav lightbox-nav--prev"
            (click)="prev()"
            aria-label="Previous image"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              class="h-8 w-8"
              aria-hidden="true"
            >
              <path d="M15 19l-7-7 7-7" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>

          <button
            id="next-image"
            type="button"
            class="lightbox-nav lightbox-nav--next"
            (click)="next()"
            aria-label="Next image"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              class="h-8 w-8"
              aria-hidden="true"
            >
              <path d="M9 5l7 7-7 7" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
        }
      }
    </div>

    <!-- Tour mode -->
    @if (mode() === 'tour') {
      <div class="lightbox-tour" #tourWrapper (window:resize)="updateVideoPlayerSize()">
        @if (youtubeId() && isOpen()) {
          <youtube-player
            [videoId]="youtubeId()"
            [height]="tourHeight()"
            [width]="tourWidth()"
            [disableCookies]="true"
            [playerVars]="{ autoplay: 1, mute: 1, modestbranding: 1, rel: 0, playsinline: 1 }"
            (ready)="onTourReady($event)"
            (stateChange)="onTourStateChange($event)"
          >
          </youtube-player>
        }
      </div>
    }

    <!-- Map mode -->
    <div class="lightbox-map" [style.display]="mode() !== 'map' ? 'none' : null">
      <app-lightbox-map [listingId]="listingId()" class="block w-full h-full" />
    </div>
  </div>
</dialog>
